
const Data = {

    //SafetyCoaching
    JobTitle: [
        { Id: 1, Text: "Housekeeper", Value: "Housekeeper" },
        { Id: 2, Text: "Floor Tech", Value: "Floor Tech" },
        { Id: 3, Text: "Trash Tech", Value: "Trash Tech" }
    ],
    Category:
        [
            {
                Id: 1, Key: "Sprains & Strains", Values:
                    [
                        { Id: 1, Value: "Testing the load before lifting" },
                        { Id: 2, Value: "Lifting technique" },
                        { Id: 3, Value: "Team lift" },
                        { Id: 4, Value: "Called for help" }

                    ]
            },
            {
                Id: 2, Key: "Struck-By & Caught In-Between", Values:
                    [
                        { Id: 1, Value: "Hand placement on doors or door frames" },
                        { Id: 2, Value: "Body positioning to stay out of the line of fire" },
                        { Id: 3, Value: "Body positioning when using a cart" },
                    ]
            },
            {
                Id: 3, Key: "Slip & Fall", Values:
                    [
                        { Id: 1, Value: "Wet floor signs" },
                        { Id: 2, Value: "Mopping away from the path of travel (mopping out)" },
                        { Id: 3, Value: "Liquid on ground" },
                        { Id: 4, Value: "Cords running on ground" },
                        { Id: 5, Value: "Trip Hazards" },
                        { Id: 6, Value: "Slip Resistant Shoes" },
                    ]
            },
            {
                Id: 4, Key: "Chemicals", Values:
                    [
                        { Id: 1, Value: "Goggle use" },
                        { Id: 2, Value: "Chemical use" },
                        { Id: 3, Value: "Chemical labeling" },
                        { Id: 4, Value: "Food or drink or cart" }
                    ]
            },
            {
                Id: 5, Key: "Other", Values: []
            }
        ],

    //Visitation Log
    patientRequestsData: [
        { id: 1, name: 'Cleaning Request' },
        { id: 2, name: 'Linen Request' },
        { id: 3, name: 'Maintenance Request' },
        { id: 4, name: 'Nursing Request' },
        { id: 5, name: 'Nurse\'s Aide Request' },
        { id: 6, name: 'Food and Nutrition Services Request' },
        { id: 7, name: 'Patient Transportation Request' },
        { id: 8, name: 'Other Request' },
        { id: 9, name: 'No Requests' }

    ],

    //Service Recovery

    roundStates : [
        { id: 1, name: 'All' },
        { id: 2, name: 'Unsatisfactory' },
        { id: 3, name: 'Completed' },
        { id: 4, name: 'Confirmed' }
    ],

    recoveryLogStates : [
        { id: 1, name: 'All' },
        { id: 2, name: 'Unsatisfactory' },
        { id: 3, name: 'Completed' },
        { id: 4, name: 'Confirmed' }
    ],

    rounds : [
        { id: 1, name: '1ST Round' },
        { id: 2, name: '2ND Round' },
        { id: 3, name: '3RD Round' }
    ],
    safeRoomCheckList : [
        { Id: 1, Checked: false, Text: "Review Suicide Environmental Checklist on Patient Observation Documentation." },
        { Id: 2, Checked: false, Text: "Note any feels, events, or symptoms that may lead to a crisis/document response." },
        { Id: 3, Checked: false, Text: "Ask patient what helps him/her cope in a crisis and document responses (e.g., read, listen to music, etc.)." },
        { Id: 4, Checked: false, Text: "Remove any Cords including phone." },
        { Id: 5, Checked: false, Text: "Remove restraint limbs and belts." },
        { Id: 6, Checked: false, Text: "Remove any elastic tubing." },
        { Id: 7, Checked: false, Text: "Remove extra bed sheets and linen." },
        { Id: 8, Checked: false, Text: "Remove oxygen tubing, suction tubing, IV tubing and pole, cardiac monitoring lead sets that are not needed for patient care." },
        { Id: 9, Checked: false, Text: "High-Risk Patients Only: Remove call light cable and replace with 'nub' to maintain the call system." },
        { Id: 10, Checked: false, Text: "Remove all unnecessary furniture from room (e.g., step stool, over-bed table, etc.)." },
        { Id: 11, Checked: false, Text: "Remove the waste basket liners." },
        { Id: 12, Checked: false, Text: "Curtains must remain open so that the patient is in full-view of hospital staff." },
        { Id: 13, Checked: false, Text: "Patient should be placed in a hospital goes that does not have ties." },
        { Id: 14, Checked: false, Text: "All clothes and patient belongings should be secured (all valuables must be put in a valuables envelope, itemize and secured)." },
        { Id: 15, Checked: false, Text: "All home medications should be documented and sent to the pharmacy." },
        { Id: 16, Checked: false, Text: "Secure the headwall –keep the TV out of the patients’ reach unless in use by the patient and monitored by the Patient Observation Attendant." },
        { Id: 17, Checked: false, Text: "Light must remain on so patient can be visualized at all times." },
        { Id: 18, Checked: false, Text: "Appropriate dietary trays are available to the patient at all times. " }
    ],
    attendantChecklist:
        {
            SituationalAwareness: {
                Title: 'Situational Awareness',
                Items: [
                    { Id: 1, Text: 'Specific safety concerns of this patient have been reviewed and explained to me by patient’s nurse and/or charge nurse prior to observing patient. Including but not limited to the following: High fall-risk, pulling on IV, catheter, getting out of bed, kicking, punching, aggressive, NPO, etc.' },
                    { Id: 2, Text: 'Does this patient have a history of violent behavior, or have they shown any aggressive behavior during admission or while at the hospital?' }
                ]
            },
            ObserverAcknowledgement: {
                Title: 'Observer Acknowledgement',
                Items: [
                    { Id: 1, Text: 'I am responsible for close patient observation at all times during my shift.' },
                    { Id: 2, Text: 'I will keep patient within my line of sight at all times.' },
                    { Id: 3, Text: 'I will remain with the patient at all times.' },
                    { Id: 4, Text: 'I will accompany the patient off the unit during their diagnostic testing or treatments as requested by clinical staff and maintain an unobstructive view of the patient unless otherwise directed by RN or test/procedural area staff.' },
                    { Id: 5, Text: 'I will gather data/information for clinical staff and other Patient Safety Attendants regarding patient behaviors including content and patient verbalization.' },
                    { Id: 6, Text: 'I will reorient the patient as to person, place, and time as needed.' },
                    { Id: 7, Text: 'I will maintain a low calm voice when interacting with the patient.' },
                    { Id: 8, Text: 'I will respect patient privacy.' },
                    { Id: 9, Text: 'I will NOT leave the patient for any reason without discussing situation with Nursing. ' },
                    { Id: 10, Text: 'I will safeguard the patient’s environment by removing any potential dangerous items and alerting the Nurse.' },
                    { Id: 11, Text: 'I will document patient-state every 15-minutes to update clinical team.I will also update patient-state in hospital’s EMR (if applicable).' },
                    { Id: 12, Text: 'I will remain alert and observant at all times.' },
                    { Id: 13, Text: 'I will deescalate and gently calm/stop patients to prevent possible injury/harm.' },
                    { Id: 14, Text: 'Confirmed with the patient’s nurse if the patient has a history of violent behavior, or if they have shown any aggressive behavior during admission or while at the hospital.' }
                ]
            }
        }
        
};
export default Data